import saveAs from "file-saver";
import { FloorPlan } from "../objects/FloorPlan";
import { Action } from "./Action";

/**
 * The whole plan comes out as one JSON file. That file is the sharing format:
 * hand it to someone else, they load it, and they see exactly what you saw.
 */
export class SaveAction implements Action {

    private receiver: FloorPlan;
    constructor() {
        this.receiver = FloorPlan.Instance;
    }

    public execute() {
        let data = this.receiver.save();
        let blob = new Blob([data], { type: "application/json;charset=utf-8" });
        const stamp = new Date().toISOString().slice(0, 10);
        saveAs(blob, `room-plan-${stamp}.json`);
    }
}
